import { useEffect } from "react"

export const useOnResize = (callback: () => void, scope?: any[]) => {
  useEffect(() => {
    let timeoutId: any = null
    const handleResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => callback(), 100)
    }
    window.addEventListener("resize", handleResize)
    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener("resize", handleResize)
    }
  }, scope)
}
